export const types = {
    GET_INFLUENCERS_REQUEST: 'GET_INFLUENCERS_REQUEST',
    GET_INFLUENCERS_SUCCESS: 'GET_INFLUENCERS_SUCCESS',
    GET_INFLUENCERS_FAILURE: 'GET_INFLUENCERS_FAILURE',

    CREATE_UPDATE_INFLUENCERS_REQUEST: 'CREATE_UPDATE_INFLUENCERS_REQUEST',
    CREATE_UPDATE_INFLUENCERS_SUCCESS: 'CREATE_UPDATE_INFLUENCERS_SUCCESS',
    CREATE_UPDATE_INFLUENCERS_FAILURE: 'CREATE_UPDATE_INFLUENCERS_FAILURE',

    DELETE_INFLUENCERS_REQUEST: 'DELETE_INFLUENCERS_REQUEST',
    DELETE_INFLUENCERS_SUCCESS: 'DELETE_INFLUENCERS_SUCCESS',
    DELETE_INFLUENCERS_FAILURE: 'DELETE_INFLUENCERS_FAILURE',
    
    CHECK_EXISTING_INFLUENCERS_REQUEST: 'CHECK_EXISTING_INFLUENCERS_REQUEST',
    CHECK_EXISTING_INFLUENCERS_SUCCESS: 'CHECK_EXISTING_INFLUENCERS_SUCCESS',
    CHECK_EXISTING_INFLUENCERS_FAILURE: 'CHECK_EXISTING_INFLUENCERS_FAILURE',

    CREATE_PROMOCODE_REQUEST: 'CREATE_PROMOCODE_REQUEST',
    CREATE_PROMOCODE_SUCCESS: 'CREATE_PROMOCODE_SUCCESS',
    CREATE_PROMOCODE_FAILURE: 'CREATE_PROMOCODE_FAILURE',

    GET_PROMOCODE_REQUEST: 'GET_PROMOCODE_REQUEST',
    GET_PROMOCODE_SUCCESS: 'GET_PROMOCODE_SUCCESS',
    GET_PROMOCODE_FAILURE: 'GET_PROMOCODE_FAILURE',

    UPDATE_PROMOCODE_REQUEST: 'UPDATE_PROMOCODE_REQUEST',
    UPDATE_PROMOCODE_SUCCESS: 'UPDATE_PROMOCODE_SUCCESS',
    UPDATE_PROMOCODE_FAILURE: 'UPDATE_PROMOCODE_FAILURE',

    DELETE_PROMOCODE_REQUEST: 'DELETE_PROMOCODE_REQUEST',
    DELETE_PROMOCODE_SUCCESS: 'DELETE_PROMOCODE_SUCCESS',
    DELETE_PROMOCODE_FAILURE: 'DELETE_PROMOCODE_FAILURE',
    
    SEND_PAYOUT_REQUEST: 'SEND_PAYOUT_REQUEST',
    SEND_PAYOUT_SUCCESS: 'SEND_PAYOUT_SUCCESS',
    SEND_PAYOUT_FAILURE: 'SEND_PAYOUT_FAILURE',

    ADMIN_REVIEW_AFFILIATE_REQUEST: 'ADMIN_REVIEW_AFFILIATE_REQUEST',
    ADMIN_REVIEW_AFFILIATE_SUCCESS: 'ADMIN_REVIEW_AFFILIATE_SUCCESS',
    ADMIN_REVIEW_AFFILIATE_FAILURE: 'ADMIN_REVIEW_AFFILIATE_FAILURE',

    INFLUENCER_SIGNUP_REQUEST: 'INFLUENCER_SIGNUP_REQUEST',
    INFLUENCER_SIGNUP_SUCCESS: 'INFLUENCER_SIGNUP_SUCCESS',
    INFLUENCER_SIGNUP_FAILURE: 'INFLUENCER_SIGNUP_FAILURE',
}